module.exports = __webpack_public_path__ + "img/4.890b1358.jpeg";